export default "__VITE_ASSET__D6du38ev__"